export default __webpack_public_path__ + "static/media/billard-clipart-pool-table-bg.64402728.png";